import { render, staticRenderFns } from "./WaitingInputParcel.vue?vue&type=template&id=55e25216&scoped=true&"
import script from "./WaitingInputParcel.vue?vue&type=script&lang=js&"
export * from "./WaitingInputParcel.vue?vue&type=script&lang=js&"
import style0 from "./WaitingInputParcel.vue?vue&type=style&index=0&id=55e25216&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e25216",
  null
  
)

export default component.exports